export enum TransferRecipientAccountTypeEnum {
  Deposit = 'Deposit',
  Savings = 'Savings',
  Card = 'Card',
  Iban = 'Iban',
  Other = 'Other',
}
